var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tag",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:currentColor}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21619",
    "data-name": "Group 21619"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17722",
    "data-name": "Path 17722",
    className: "cls-2",
    d: "m21.41 11.58-9-9A1.987 1.987 0 0 0 11 2H4a2.006 2.006 0 0 0-2 2v7a2 2 0 0 0 .59 1.42l9 9A1.987 1.987 0 0 0 13 22a1.955 1.955 0 0 0 1.41-.59l7-7A1.955 1.955 0 0 0 22 13a2.02 2.02 0 0 0-.59-1.42zM13 20.01 4 11V4h7v-.01l9 9z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1815",
    "data-name": "Ellipse 1815",
    className: "cls-2",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(5 5)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.bafb30617402f0df1122bb7178035c8b.svg";
export { ForwardRef as ReactComponent };